import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { getContribuyente } from 'api/empresas/contribuyentes';

export const baseURI = 'empresas/contribuyentes-notarios/';

/**
 * GET NotariosPredios
 * @param {Object} [params]
 * @returns {Promise<object[]>}
 */
export const getNotariosPredios = async (params = {}) => {
  try {
    const response = await API.get(baseURI, { params });
    if (!params.page) [{ id: 0, nombre_completo: 'Otro' }].concat(response.data);
    return response.data;
  } catch (err) {
    onError(err);
    return params.page ? { results: [] } : [];
  }
};

/**
 * GET NotarioDePredio
 * @param {Object} [params]
 * @returns {Promise<object[]>}
 */
export const getCatalogoNotariosDePredios = async (_params = {}) => {
  const params = { ..._params, es_notario: true, page_size: 500 };
  try {
    const response = await API.get('/empresas/contribuyentes-ligero/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return params.page ? { results: [] } : [];
  }
};

/**
 * GET NotarioDePredio
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getNotarioDePredio = async (id) => getContribuyente(id);

/**
 * POST NotarioDePredio
 * @param {object} values
 * @returns {Promise<object|null>}
 */
export const postNotarioDePredio = async (_values) => {
  const values = { ..._values, es_notario: true, tipo_de_persona: 1 };
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * PATCH NotarioDePredio
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|null>}
 */
export const patchNotarioDePredio = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE NotarioDePredio
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteNotarioDePredio = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
